import {environment} from '../environments/environment';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable, Subject} from 'rxjs/Rx';

import {Router} from '@angular/router';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';

import {Usuario} from '../model/usuario';
import {CookieService} from 'ngx-cookie';
import {CookieOptions} from 'ngx-cookie';
import {ModalService} from '../service/modal.service';
import {JQueryStatic} from 'jquery';

declare var $: JQueryStatic;

@Injectable()
export class GlobalService {

    usuario: Usuario;
    autenticado: boolean = false;
    usuarioChange: Subject<Usuario> = new Subject<Usuario>();
    configuracao;
    erro: boolean = false;
    loading: boolean = false;
    timedOut = false;
    lastPing?: Date = null;
    escopos: string[];
    idleState = 'Not started.';
    timeRefresh: Date = new Date();


    constructor(private http: HttpClient, private router: Router, private idle: Idle, private keepalive: Keepalive, private cookieService: CookieService, private modalService: ModalService) {
    }

    setCookieUsuarioLogado(): boolean {
        this.usuario = <Usuario>this.cookieService.getObject('usuarioCadastro');
        if (this.usuario != null) {
            this.autenticado = true;
            return true;
        }
        this.autenticado = false;
        return false;
    }


    abrirModalLogin(): void {

        if (this.autenticado) {
            return;
        }

        let loginModal = $('#loginModal');
        this.modalService.fecharPaginaModal();
        loginModal.addClass('abrirModal');
        loginModal.removeClass('fechado');
        $('#loginModalOverlay').removeClass('fechado');
    }


    fecharModalLogin(): void {
        $('#loginModal #chave').val('');
        $('#loginModal #senha').val('');
        let loginModal = $('#loginModal');
        loginModal.removeClass('abrirModal');
        loginModal.addClass('fechado');
        $('#loginModalOverlay').addClass('fechado');

        if (!this.autenticado) {
            this.router.navigate(['/login']);
        }
    }

    idleFunction(idle: Idle, keepalive: Keepalive) {
        // sets an idle timeout of 10 seconds, for testing purposes.
        idle.setIdle(600);
        // sets a timeout period of 15 minutes. after 15 minutes of inactivity, the user will be considered timed out.
        idle.setTimeout(10);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);


        idle.onIdleEnd.subscribe(() => {
            this.idleState = 'NO_LONGER_IDLE';
        });

        idle.onIdleStart.subscribe(() => {
            this.idleState = 'IDLE_START';
            console.log('idleStart');
        });

        idle.onTimeoutWarning.subscribe((countdown: any) => {
            this.idleState = 'IDLE_TIME_IN_PROGRESS';
            this.modalService.exibirMensagem('Sessão Expirada!', 'Sua sessão será fechada em :  ' + countdown + ' segundos', 'Atualizar sessão');
        });


        idle.onTimeout.subscribe(() => {
            this.timedOut = true;
            this.logoutUsuario();
            this.autenticado = false;
            this.abrirModalLogin();
        });

        // Função para manter o Token do usuário ativo.
        this.keepalive.interval(1680);
        keepalive.onPing.subscribe(() => {

            this.resetIdle();
            if (this.autenticado && this.tokenExpirado()) {
                this.renovarToken(this.usuario.refresh_token).take(1)
                    .subscribe(
                        usuario => {
                            var now = new Date();
                            this.usuario.access_token = usuario.access_token;
                            this.usuario.data_expiracao = usuario.data_expiracao;
                            this.usuario.emitido_em = now.getTime().toString();
                            this.autenticado = true;
                            this.lastPing = new Date();
                        },
                        error => {
                            this.timedOut = true;
                            this.logoutUsuario();
                            this.abrirModalLogin();
                            this.autenticado = false;
                            this.lastPing = null;
                        }
                    );
            }
        });

    }

    resetIdle() {

        var now = new Date();
        this.idle.watch();
        this.timedOut = false;
    }

    carregarConf() {
        // this.http.get("gmt-cadastro-web-configlib.json").take(1)
        // .subscribe(
        // response => {

        let ambiente = location.hostname;

        switch (true) {
            case ambiente.indexOf('desenv.bb.com.br') > 0:
                this.configuracao = environment.configDesenv;
                break;
            case ambiente.indexOf('hm.bb.com.br') > 0:
                this.configuracao = environment.configHm;
                break;
            case ambiente.indexOf('edi.bb.com.br') > 0:
                this.configuracao = environment.configProd;
                break;
            case ambiente.indexOf('tor.bb.com.br') > 0:
                this.configuracao = environment.configProdTor;
                break;
            case ambiente == '10.254.112.202':
                this.configuracao = environment.configProdTor;
                break;
            default:
                this.configuracao = environment.configLocalDes;
                break;
        }

        // verificar se tem usuario no cookie
        var usuario = <Usuario>this.cookieService.getObject('usuarioCadastro');
        if (usuario != null && !this.tokenExpirado()) {
            this.loading = true;
            this.lastPing = new Date();
            this.renovarToken(usuario.refresh_token).take(1)
                .subscribe(
                    usuarioToken => {
                        var now = new Date();
                        usuario.access_token = usuarioToken.access_token;
                        usuario.data_expiracao = usuarioToken.data_expiracao;
                        usuario.emitido_em = now.getTime().toString();
                        this.loginUsuario(usuario);
                        this.loading = false;
                    },
                    error => {
                        this.timedOut = true;
                        this.logoutUsuario();
                        this.abrirModalLogin();
                        this.loading = false;
                    }
                );
        }
        // },
        // error => { }
        // );
    }


    logOut() {
        this.idle.stop();
        this.keepalive.stop();
        this.keepalive.ngOnDestroy();
        this.idle.ngOnDestroy();
        this.idle.clearInterrupts();
        localStorage.clear();
    }

    getConfiguracao() {
        return this.configuracao;
    }

    tokenExpirado(): boolean {
        if (this.setCookieUsuarioLogado()) {
            var now = new Date();
            var fimToken = new Date(this.usuario.data_expiracao);
            if (Number(fimToken.getTime()) < Number(now.getTime())) {
                return true;
            }
        } else {
            this.abrirModalLogin();
        }
        return false;
    }

    loginUsuario(usuario: Usuario) {
        var options: CookieOptions = {};
        var data = new Date();
        if (data.getHours() > 2) {
            data.setHours(data.getHours() - 3);
        } else {
            data.setHours(21 + data.getHours());
        }
        if (data.getMinutes() < 30) {
            data.setMinutes(data.getMinutes() + 30);
        } else {
            if (data.getHours() < 23) {
                data.setHours(data.getHours() + 1);
            } else {
                data.setHours(0);
            }
            data.setMinutes(data.getMinutes() - 30);
        }
        options.expires = data;
        this.cookieService.putObject('usuarioCadastro', usuario, null);
        localStorage.setItem('access_token', usuario.access_token);
        localStorage.setItem('refresh_token', usuario.refresh_token);
        this.timedOut = false;
        this.usuario = usuario;
        this.autenticado = true;
        this.usuarioChange.next(this.usuario);
        this.idleFunction(this.idle, this.keepalive);
        this.resetIdle();
    }

    logoutUsuario() {
        this.cookieService.putObject('usuarioCadastro', null, null);
        localStorage.setItem('access_token', '');
        this.autenticado = false;
        this.usuario = null;
        this.usuarioChange.next(null);
        this.logOut();
        localStorage.clear();
    }

    getUsuario(): Usuario {
        if (this.usuario == null) {
            this.usuario = <Usuario>this.cookieService.getObject('usuarioCadastro');
            if (this.tokenExpirado()) {
                this.renovarToken(this.usuario.access_token);
            }
        }
        return this.usuario;
    }

    getUsername(): String {
        let username: any = '';
        if (this.usuario.userData != null) {
            if (this.usuario.userData.tipoUsuario.toString() === '1') {
                username = this.usuario.userData.userAplicacao.username;
            }
            if (this.usuario.userData.tipoUsuario.toString() === '2') {
                username = this.usuario.userData.userExterno.username;
            }
            if (this.usuario.userData.tipoUsuario.toString() === '3') {
                username = this.usuario.userData.userInterno.username;
            }
        }
        return username;
    }

    estaAutenticado(): boolean {
        return this.autenticado;
    }

    renovarToken(refresh_token: string) {
        let dados = new HttpParams();
        dados = dados.append('grant_type', 'refresh_token');
        dados = dados.append('refresh_token', refresh_token);
        let url: string = this.configuracao.api_autorizador + '/autoriza';

        return this.http.post<Usuario>(url, dados, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}});
    }

    logoutRedirect() {
        this.logoutUsuario();
        this.router.navigate(['/login']);
    }

}



// WEBPACK FOOTER //
// ./src/service/global.service.ts